import React from 'react';
import styles from './logo.module.scss';
import logo from '@/logo.png';
import { Link } from 'react-router-dom';

const Logo: React.FC = () => {
  return (
    <Link to="/">
      <img className={styles.logo} src={logo} width="213" height="50" alt="لوگوی تکست نویس" />
    </Link>
  );
}

export default Logo;